<template>
  <RF-Dialog class="contrato-form-dialog"
    :cpntStatus='statusGeral'
    :cpntLargura='"1200px"'
    :cpntTitulo='"Novo Fechamento"'

    :cpntOnFecharDialog='cpntFecharFormulario'>
      <template slot='conteudo' v-if="Object.keys(formulario).length >= 1 && formulario.status === ''">
        <div class="comGerFechamento" :style="formulario.field.comissionado.value === '' ? 'min-height: 75px; max-height: 75px;' : ''">
          <div>
            <RF-Filtro-Busca-Telas :data-time="time" :style="'float: unset !important; width: 100% !important; display: inline-block'"
              :cpntTime='time'
              :cpntStatus='formulario.status'
              :cpntField='formulario.field'

              :cpntOnRealizaBusca='comGerFechamentoTabelaIniciar'
              :ref='formulario.id + "-filtro"'
            ></RF-Filtro-Busca-Telas>

            <RF-Input-Calendario  :data-time="time" v-if="formulario.field.comissionado.value !== ''"
              :cpntStatus='formulario.field.vencimento.status'
              :cpntId='formulario.field.vencimento.id'
              :cpntClassDivField='formulario.field.vencimento.classDivField'
              :cpntNome='formulario.field.vencimento.nome'
              :cpntValue='formulario.field.vencimento.value'
              :cpntAutoComplete='formulario.field.vencimento.autocomplete'
              :cpntMask='formulario.field.vencimento.mask'
              :cpntDisabled='formulario.field.vencimento.disabled'
              :cpntAutoFocus='formulario.field.vencimento.autofocus'
              :cpntMensagem='formulario.field.vencimento.mensagem'
              :cpntMensagemTipo='formulario.field.vencimento.mensagemTipo'
              :cpntPlaceholder='formulario.field.vencimento.placeholder'

              :cpntOnChange='formulario.field.vencimento.onChange'
              :ref='formulario.field.vencimento.id'
            ></RF-Input-Calendario>
          </div>

          <div>
            <div v-if="(Object.keys(tabelaProduto).length >= 1 && tabelaProduto.flagDiff === true) || Object.keys(tabelaServico).length >= 1 && tabelaServico.flagDiff === true" class="comGerFechamento-diff">
              Existe 
              <template v-if="tabelaProduto.flagDiff === true && tabelaServico.flagDiff === true"><span> produtos e serviços </span></template>
              <template v-else-if="tabelaProduto.flagDiff === true"><span> produtos </span></template>
              <template v-else-if="tabelaServico.flagDiff === true"><span> serviços </span></template>
              que estão com a % de comissão desatualizada.

              <RF-Button
                :data-time='time'

                :cpntStatus='buttonDiff.status' 
                :cpntId='buttonDiff.id' 
                :cpntTexto='buttonDiff.texto' 
                :cpntClass='buttonDiff.class'
                :cpntMostrar='buttonDiff.mostrar'
                :cpntTabIndex='buttonDiff.tabIndex'

                @onClickButton='buttonDiff.onClick'
              ></RF-Button>
            </div>


            <div v-if='Object.keys(tabelaTotais).length >= 1' class="comGerFechamento-tab">
              <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, null, null, null, null, false) === true && Object.keys(tabelaProduto).length >= 1">
                <div v-if="tabelaProduto.status === '' && tabelaProduto.linha.length >= 1">
                  PRODUTOS

                  <span style="font-size: var(--font-base-soma-12);">R${{ tabelaProduto.calculos.val_formatado }}</span>
                  <RF-Explica :key="tabelaProduto.calculos.bc_formatado + '-' + tabelaProduto.calculos.por_formatado"
                    :cpntId='tabelaProduto.id + "-info-tot"' 
                    :cpntTitle='"<table><tr><td>Base de cálculo: </td><td>&nbsp;</td><td>" + tabelaProduto.calculos.bc_formatado + "</td></tr><tr><td>Porcentagem média:</td><td>&nbsp;</td><td>" + tabelaProduto.calculos.por_formatado + "%</td></tr></table>"'
                  ></RF-Explica>
                </div>

                <RF-Tabela :data-time="time" style="margin-top: 5px; margin-bottom: 15px"
                  :cpntTime='time'
                  :cpntId='tabelaProduto.id'
                  :cpntStatus='tabelaProduto.status'
                  :cpntButtonImprimir='tabelaProduto.acoes.btImprimir'
                  :cpntButtonAtualizar='tabelaProduto.acoes.btAtualizar'
                  :cpntFraseTop='tabelaServico.fraseTop'
                  :cpntColuna='tabelaProduto.coluna'
                  :cpntLinha='tabelaProduto.linha2'
                  :cpntCountAll='tabelaProduto.countAll'
                  :cpntColspan='tabelaProduto.colspan'
                  :cpntRowspan='tabelaProduto.rowspan'
                  :cpntButtonsAcoes='tabelaProduto.acoes.buttons'
                  :cpntMper='tabelaProduto.mper'
                  :cpntPagina='tabelaProduto.pagina'
                  :cpntCheckboxEditar='tabelaProduto.checkboxEditar'
                  :cpntMostrar='tabelaProduto.mostrar'
                  :cpntFieldsEditar='tabelaProduto.acoes.fields'

                  :cpntOnRefreshTabela='comGerFechamentoTabelaIniciar'
                  :cpntOnCheckboxAtualiza='comGerFechamentoTabelaOnCheckboxAtualiza'
                  :ref='tabelaProduto.id'
                ></RF-Tabela>
              </template>

              <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === true && Object.keys(tabelaServico).length >= 1">
                <div v-if="tabelaServico.status === '' && tabelaServico.linha.length >= 1">
                  SERVIÇO

                  <span style="font-size: var(--font-base-soma-12);">R${{ tabelaServico.calculos.val_formatado }}</span>
                  <RF-Explica :key="tabelaServico.calculos.bc_formatado + '-' + tabelaServico.calculos.por_formatado"
                    :cpntId='tabelaServico.id + "-info-tot"' 
                    :cpntTitle='"<table><tr><td>Base de cálculo: </td><td>&nbsp;</td><td>" + tabelaServico.calculos.bc_formatado + "</td></tr><tr><td>Porcentagem média:</td><td>&nbsp;</td><td>" + tabelaServico.calculos.por_formatado + "%</td></tr></table>"'
                  ></RF-Explica>
                </div>

                <RF-Tabela :data-time="time" style="margin-top: 5px; margin-bottom: 15px"
                  :cpntTime='time'
                  :cpntId='tabelaServico.id'
                  :cpntStatus='tabelaServico.status'
                  :cpntButtonImprimir='tabelaServico.acoes.btImprimir'
                  :cpntButtonAtualizar='tabelaServico.acoes.btAtualizar'
                  :cpntFraseTop='tabelaServico.fraseTop'
                  :cpntColuna='tabelaServico.coluna'
                  :cpntLinha='tabelaServico.linha2'
                  :cpntCountAll='tabelaServico.countAll'
                  :cpntColspan='tabelaServico.colspan'
                  :cpntRowspan='tabelaServico.rowspan'
                  :cpntButtonsAcoes='tabelaServico.acoes.buttons'
                  :cpntMper='tabelaServico.mper'
                  :cpntPagina='tabelaServico.pagina'
                  :cpntCheckboxEditar='tabelaServico.checkboxEditar'
                  :cpntMostrar='tabelaServico.mostrar'
                  :cpntFieldsEditar='tabelaServico.acoes.fields'

                  :cpntOnRefreshTabela='comGerFechamentoTabelaIniciar'
                  :cpntOnCheckboxAtualiza='comGerFechamentoTabelaOnCheckboxAtualiza'
                  :ref='tabelaServico.id'
                ></RF-Tabela>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template slot='rodape' v-if="Object.keys(formulario).length >= 1 && formulario.status === '' && formulario.field.comissionado.value !== ''">
        <div class="comGerFechamento-rodape">
          <table class="cms-total">
            <tr>
              <td>
                <div style="border: none !important; background: none;">&nbsp;</div>
              </td>
              <td>
                <div style="border-top-left-radius: 5px;">Total</div>
              </td>
              <td>
                <div style="border-top-right-radius: 5px;">Total Selecionado</div>
              </td>
            </tr>
            <tr>
              <td>
                <div style="border-top-left-radius: 5px;">Vendido</div>
              </td>
              <td>
                <div>R$ {{ tabelaTotais.bc_formatado }}</div>
              </td>
              <td>
                <div>R$ {{ tabelaTotaisSelecionado.bc_formatado }}</div>
              </td>
            </tr>
            <tr>
              <td>
                <div style="border-bottom-left-radius: 5px;">Comissão</div>
              </td>
              <td>
                <div>R$ {{ tabelaTotais.val_formatado }}</div>
              </td>
              <td>
                <div style="border-bottom-right-radius: 5px;">R$ {{ tabelaTotaisSelecionado.val_formatado }}</div>
              </td>
            </tr>

            <tr>
              <td colspan="3" style="padding: 10px 0px;">
                <RF-Button :key="index" v-for='(button, index) in formulario.buttons' style="margin: 0px 5px"
                  :data-time='time'

                  :cpntStatus='button.status' 
                  :cpntId='button.id' 
                  :cpntTexto='button.texto' 
                  :cpntClass='button.class'
                  :cpntMostrar='button.mostrar'
                  :cpntTabIndex='button.tabIndex'

                  @onClickButton='button.onClick'
                ></RF-Button>
              </td>
            </tr>
          </table>
        </div>
      </template>
  </RF-Dialog>
</template>

<style scoped>
  .comGerFechamento > div > div.comGerFechamento-diff {
    width: 100%;
    margin: 20px 0px 10px 0px;
    padding: 10px;
    text-align: center;

    border: 1px solid #f0ad4e;
    border-radius: 5px;
  }

  .comGerFechamento-tab {
    clear: both;
    padding-top: 10px;
  }
    .comGerFechamento-tot {
      font-size: var(--font-base-soma-16);
      text-align: center;
      font-weight: 600;
    }
  .comGerFechamento-rodape {
    padding: 10px;
    text-align: center;
  }
    .comGerFechamento-rodape > button {
      margin: 0px 5px;
    }

  .cms-total {
    border-collapse: collapse;
    width: 400px;
    margin: 0px auto;
  }
    .cms-total > tr > td {
      padding: 0px;
    }
      .cms-total > tr > td > div {
        padding: 3px 5px;
        background: #f9f9f9;
        border: 1px solid #ddd;
      }
    .cms-total > tr > td:first-child {
      width: 100px;
      text-align: center;
    }
    .cms-total > tr > td {
      width: calc(100% / 3);
      text-align: right;
    }
    .cms-total > tr:last-child > td {
      border: none;
      background: none;
      text-align: center
    }
    .cms-total > tr:not(:first-child):not(:last-child) > td:last-child {
      color: red;
    }
</style>

<style>
  .comGerFechamento > div > .rf-tabela-filtro-tela {
    text-align: left !important;
    width: 100%;
    display: initial !important;
    width: initial !important;
  }
  .comGerFechamento > div > .rf-tabela-filtro-tela,
  .comGerFechamento > div > .rf-tabela-filtro-tela ~ .rf-input-group {
    display: inline-block;
  }
  .comGerFechamento > div > .rf-tabela-filtro-tela ~ .rf-input-group {
    margin-right: 10px;
    margin-bottom: 0px;
  }

  .app-mobile .comGerFechamento > div > .rf-tabela-filtro-tela > .rf-filtro-tela-comissionado {
    display: block !important;
    padding-bottom: 22px;
    margin: 0px !important;
    width: 100%;
  }
  :not(.app-mobile) .comGerFechamento > div > .rf-tabela-filtro-tela > .rf-filtro-tela-data {
    max-width: 430px !important;
  }
  .app-mobile .comGerFechamento > div > .rf-tabela-filtro-tela > .rf-filtro-tela-data {
    display: block !important;
    padding-bottom: 22px;
    margin: 0px !important;
    width: 100%;
    max-width: 430px !important;
  }
  .app-mobile .comGerFechamento > div > .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > .rf-input-group {
    width: 100%;
    max-width: 115px;
  }
  .comGerFechamento > div > .rf-tabela-filtro-tela ~ .rf-input-group > input,
  .app-mobile .comGerFechamento > div > .rf-tabela-filtro-tela > .rf-filtro-tela-data > table > tr > td > .rf-input-group > input {
    border: 1px solid #CCC;
    border-radius: 3px;
  }

  .comGerFechamento > div > .rf-tabela-filtro-tela > .rf-filtro-tela-comissionado,
  .comGerFechamento > div > .rf-tabela-filtro-tela > .rf-filtro-tela-vencimento {
    width: 230px;
    margin: 5px 10px 0px 10px !important;
    text-align: right;
  }
  .comGerFechamento > div > .rf-tabela-filtro-tela > .rf-filtro-tela-vencimento {
    display: inline-block;
  }
  @media only screen and (min-height: 0px) and (max-height: 660px) {
    .comGerFechamento {
      min-height: 400px;
      max-height: 400px;
    }
  }
  @media only screen and (min-height: 661px) and (max-height: 760px) {
    .comGerFechamento {
      min-height: 500px;
      max-height: 500px;
    }
  }
  @media only screen and (min-height: 761px) and (max-height: 860px) {
    .comGerFechamento {
      min-height: 600px;
      max-height: 600px;
    }
  }
  @media only screen and (min-height: 861px) and (max-height: 960px) {
    .comGerFechamento {
      min-height: 700px;
      max-height: 700px;
    }
  }
  @media only screen and (min-height: 961px) and (max-height: 1060px) {
    .comGerFechamento {
      min-height: 800px;
      max-height: 800px;
    }
  }
  @media only screen and (min-height: 1061px) and (max-height: 1160px) {
    .comGerFechamento {
      min-height: 900px;
      max-height: 900px;
    }
  }
  @media only screen and (min-height: 1161px) and (max-height: 1260px) {
    .comGerFechamento {
      min-height: 1000px;
      max-height: 1000px;
    }
  }
  @media only screen and (min-height: 1261px) and (max-height: 1360px) {
    .comGerFechamento {
      min-height: 1100px;
      max-height: 1100px;
    }
  }
  @media only screen and (min-height: 1361px) and (max-height: 1460px) {
    .comGerFechamento {
      min-height: 1200px;
      max-height: 1200px;
    }
  }
  @media only screen and (min-height: 1461px) and (max-height: 1560px) {
    .comGerFechamento {
      min-height: 1300px;
      max-height: 1300px;
    }
  }
  @media only screen and (min-height: 1561px) and (max-height: 1660px) {
    .comGerFechamento {
      min-height: 1400px;
      max-height: 1400px;
    }
  }
  @media only screen and (min-height: 1661px) {
    .comGerFechamento {
      min-height: 1500px;
      max-height: 1500px;
    }
  }
  .comGerFechamento {
    padding-top: 20px;
  }
    .comGerFechamento > div > .rf-tabela-filtro-tela {
      margin: 0 auto;
      float: none !important;
      text-align: center;
    }
  .comGerFechamento-tab > div > table > tbody > tr.cms-tab-tr-divide-tipo > td {
    padding: 0px;

    background: #e9e9e9;
    border: 1px solid #ccc;
  }
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-tot-td-bc,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-tot-td-por,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-tot-td-val {
    width: 33.33%;
    min-width: 33.33%;
    max-width: 33.33%;
  }
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-pro-td-id_con_nome,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-ser-td-id_con_nome {
    width: 200px;
  }

  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-pro-td-rf-cod_venda,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-ser-td-rf-cod_venda {
    text-align: center;
    max-width: 160px;
    width: 160px;
    padding: 5px 0px;
  }
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-pro-td-cod_venda_vencimento,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-ser-td-cod_venda_vencimento {
    max-width: 132px;
    width: 132px;
  }

  tab-cms-ser-td-cms_bc
  .comGerFechamento-tab > div > table > thead > tr > th.tab-cms-pro-th-cms_bc,
  .comGerFechamento-tab > div > table > thead > tr > th.tab-cms-ser-th-cms_bc,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-pro-td-cms_bc,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-ser-td-cms_bc,

  .comGerFechamento-tab > div > table > thead > tr > th.tab-cms-pro-th-cms_por,
  .comGerFechamento-tab > div > table > thead > tr > th.tab-cms-ser-th-cms_por,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-pro-td-cms_por,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-ser-td-cms_por,

  .comGerFechamento-tab > div > table > thead > tr > th.tab-cms-pro-th-rf-cms_valor,
  .comGerFechamento-tab > div > table > thead > tr > th.tab-cms-ser-th-rf-cms_valor,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-pro-td-rf-cms_valor,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-ser-td-rf-cms_valor {
    max-width: 100px !important;
    min-width: 100px !important;
    width: 100px !important;
    text-align: center;
  }

  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-pro-td-rf-cms_valor > button,
  .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-ser-td-rf-cms_valor > button {
    margin-right: 4px;
    padding: 4px 6px;
  }
    .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-pro-td-rf-cms_valor > button > span > svg,
    .comGerFechamento-tab > div > table > tbody > tr > td.tab-cms-ser-td-rf-cms_valor > button > span > svg {
      color: #f0ad4e;
      font-size: var(--font-base-soma-18);
    }
  /*
  .comGerFechamento-tab > div > table > tbody > .rf-cms-itens-ven > td.tab-cms-pro-td-rf-nome {
    padding: 0px;
  }
    .comGerFechamento-tab > div > table > tbody > .rf-cms-itens-ven > td.tab-cms-pro-td-rf-nome > span > div {
      line-height: 31px;
      border-left: 1px solid #ccc !important;
    }
  .comGerFechamento-tab > div > table > tbody > .rf-cms-itens-ven > td.tab-cms-pro-td-rf-nome,
  .comGerFechamento-tab > div > table > tbody > .rf-cms-dados-ven > td.tab-cms-pro-td-rf-nome {
    border: none;
    max-width: 300px;
  }
  .comGerFechamento-tab > div > table > tbody > .rf-cms-dados-ven > td {
    text-align: left;
    border: none;
  }
    .comGerFechamento-tab > div > table > tbody > .rf-cms-dados-ven > td > span > .btn-default {
      text-align: left;
      width: auto !important;
      min-width: 250px !important;
      max-width: 250px !important;
      line-height: 13px !important;
    } */
  .comGerFechamento-tab > div > table > tbody > .rf-cms-venda-cinza {
    background: #f9f9f9;
  }
  .comGerFechamento-tab > div > table > tbody > .rf-cms-venda-branco {
  }
</style>

<script>
  export default {
    props: {
      cpntFecharFormulario: {
        required: false
      }
    },
    components: {
      'RF-Filtro-Busca-Telas': () => import('@/components/rf-geral/busca/RF-Busca-Telas.vue'),
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'RF-Input-Calendario': () => import('@/components/rf-geral/input-calendario/RF-Input-Calendario.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        registro: [],
        formulario: {},
        tabelaProduto: {},
        tabelaServico: {},
        tabelaTotais: { bc: 0, por: 0, val: 0 },
        tabelaTotaisSelecionado: { bc: 0, por: 0, val: 0, bc_formatado: '0,00', por_formatado: '0,00', val_formatado: '0,00', somando: false },
        vendaConIds: [],
        vendaVeiIds: [],
        buttonDiff: {}
      }
    },
    mounted: function () {
      this.comGerFechamentoInicia()
    },
    methods: {
      comGerFechamentoInicia: function () {
        // SETA O STATUS DA TELA
        this.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA CRIAR OS FORMULARIO
        this.comGerFechamentoCriarFiltro()
      },
      comGerFechamentoCriarFiltro: function () {
        var self = this

        // LIMPA OS FORMULARIO EXISTENTES
        self.formulario = {
          status: 'carregando',
          id: 'fil-com-fec',
          focus: '',
          field: {},
          tabIndexFieldGeral: 170001,
          tabIndexButtonGeral: 170001
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()


        self.formulario.field.comissionado = {              
          tipo: 'select2',
          status: '',
          tamanho: 57,
          nome: 'Vendedor',
          keyValue: 'id_con',
          keyMostra: [ 'id_con', ' - ', 'id_con_nome' ],
          value: '',
          valueIni: '',
          options: [],
          apiEnv: 'id_con',
          optionInicialNome: 'Selecione',
          optionInicialValue: '',
          onChange: function (value) {
            // SETA O VALOR RECEBIDO
            self.formulario.field.comissionado.value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS DO PERIODO
            self.comGerFechamentoBuscarPeriodo(function () {
              if (self.formulario.field.vencimento.value === '') {
                // SETA A DATA INICIAL
                self.formulario.field.vencimento.value = value

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                setTimeout(function () {
                  // INICIA O PLUGIN MOMENT PARA CALCULAR A DATA
                  var moment = require('moment')

                  // SETA A DATA PARA MAIS 1 MES DA DATA ATUAL
                  self.formulario.field.vencimento.value = moment(self.$store.state.dadosApi.datetimePtBr, 'DD-MM-YYYY HH:mm:ss').add(1, 'M').format('DD/MM/YYYY')

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()
                }, 150)
              }

              // VERIFICA SE DEVE MOSTRAR O CAMPO COMISSIONADO
              if (self.formulario.field.comissionado.value !== '') {
                self.formulario.field.data.mostrar = true
              } else {
                self.formulario.field.data.mostrar = false
              }

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              if (self.formulario.field.data.flagAlterou === false) {
                self.comGerFechamentoBuscarPeriodo(self.comGerFechamentoTabelaIniciar)
              } else {
                // CHAMA A FUNÇÃO PARA RECARREGAR A TABELA
                self.comGerFechamentoTabelaIniciar()
              }
            })
          }
        }

        // SETA OS DADOS DO FILTRO BUSCA
        self.formulario.field.data = {
          tipo: 'data', 
          status: '',
          nome: 'Período',
          value: '3',
          dataIni: '',
          dataFim: '',
          mostrar: false,
          flagAlterou: false,
          buscaApi: '',
          onChange: function (dataIni, dataFim) {
            // SETA A DATA INICIAL
            self.formulario.field.data.dataIni = dataIni

            // SETA A DATA FINAL
            self.formulario.field.data.dataFim = dataFim

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // VERIFICA SE HOUVE ALTERAÇÃO
            if (self.formulario.field.data.buscaApi !== '') {
              self.formulario.field.data.flagAlterou = self.formulario.field.data.buscaApi === window.btoa(dataIni + ' ' + dataFim)
            }

            // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS DO PERIODO
            self.comGerFechamentoBuscarPeriodo(function () {
              // // // CHAMA A FUNÇÃO PARA INICIAR NOVAMENTE
              // if (self.$refs.hasOwnProperty('fil-com-fec-filtro') && self.$refs['fil-com-fec-filtro'].hasOwnProperty('filtroSetarDataAtualizada')) {
              //   self.$refs['fil-com-fec-filtro'].filtroSetarDataAtualizada()
              // }

              self.comGerFechamentoTabelaIniciar()
            })
          }
        }

        // SETA OS DADOS DO FILTRO BUSCA
        self.formulario.field.vencimento = {
          tipo: 'input',
          status: '',
          nome: 'Vencimento',
          value: '',
          apiEnv: 'vencimento',
          id: self.formulario.id + '-vencimento',
          mostrar: false,
          onChange: function (value) {
            if (self.formulario.field.vencimento.value === '') {
              // SETA A DATA INICIAL
              self.formulario.field.vencimento.value = value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              setTimeout(function () {
                // INICIA O PLUGIN MOMENT PARA CALCULAR A DATA
                var moment = require('moment')

                // SETA A DATA PARA MAIS 1 MES DA DATA ATUAL
                self.formulario.field.vencimento.value = moment(self.$store.state.dadosApi.datetimePtBr, 'DD-MM-YYYY HH:mm:ss').add(1, 'M').format('DD/MM/YYYY')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                // DA O FOCUS NO CAMPO
                self.formulario.field.vencimento.onFocus()
              }, 150)
            } else {
              // SETA A DATA INICIAL
              self.formulario.field.vencimento.value = value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          },
          onFocus: function (tentativa = 0) {
            setTimeout(function () {
              if (self.$refs.hasOwnProperty(self.formulario.field.vencimento.id) && self.$refs[self.formulario.field.vencimento.id].hasOwnProperty('onFocusField')) {
                // SETA O FOCUS NO CAMPO
                self.$refs[self.formulario.field.vencimento.id].onFocusField(false)

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              } else if (tentativa <= 10) {
                self.formulario.field.vencimento.onFocus((tentativa + 1))
              }
            }, 50)
            self.$refs[self.formulario.field.vencimento.id]
          }
        }

        // CRIA O QUERYGET QUE SERÁ REALIZADO NA API
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id_con: { j: { nome: null } } }, where: { f: 'status', o: '=', v: '1' } }

        self.$store.state.comunicaAPI('/comissao/config/comissionado/get', 'POST', queryGet, function (apiSuccess) {
          // SETA OS VALORES RECEBIDOS
          self.formulario.field.comissionado.options = apiSuccess.data

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
          self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
            // SETA OS CAMPOS RECEBIDOS
            self.formulario.field = fields

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
              env: self.comGerFechamentoEnviarForm,
              can: () => { self.cpntFecharFormulario(false) }
            }, function (buttons) {
              // CRIA OS BUTTONS DO FORMULARIO
              self.formulario.buttons = buttons

              // SETA O STATUS DOS FORMULARIO
              self.formulario.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA CRIAR A TABELA
              self.comGerFechamentoTabelaIniciar()
            })
          })
        }, function (apiError) {
          self.comGerFechamentoErroAPi(apiError)
        })
      },
      comGerFechamentoBuscarPeriodo: function (callback = null) {
        var self = this

        if (self.formulario.field.comissionado.value !== '' && ((self.formulario.field.data.dataIni === '' || self.formulario.field.data.dataFim === '') || self.formulario.field.comissionado.valueIni !== self.formulario.field.comissionado.value)) {
          var queryGet = self.formulario.field.comissionado.value

          self.$store.state.comunicaAPI('/comissao/fechamento/periodo/get/', 'GET', queryGet, function (apiSuccess) {
            if (apiSuccess.data !== '') {
              // SETA O VALOR QUE INICIOU O PROCESSO
              self.formulario.field.comissionado.valueIni = self.formulario.field.comissionado.value

              // SETA O CAMPO PERIODO COMO PERSONALIZADO
              self.formulario.field.data.value = '7'

              // SETA A DATA INICIAL RECEBIDA
              self.formulario.field.data.dataIni = apiSuccess.data.per_ini

              // SETA A DATA FINAL RECEBIDA
              self.formulario.field.data.dataFim = apiSuccess.data.per_fim

              // SETA O FLAG COM OS DADOS DA BUSCA
              self.formulario.field.data.flagAlterou =  false 

              // SETA OS DADOS RECEIBIDOS DA API
              self.formulario.field.data.buscaApi = window.btoa(apiSuccess.data.per_ini + ' ' + apiSuccess.data.per_fim)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

            } else {
              // // SETA O CAMPO PERIODO COMO PERSONALIZADO
              // self.formulario.field.data.value = '3'
            }

            if (self.$refs.hasOwnProperty('fil-com-fec-filtro') && self.$refs['fil-com-fec-filtro'].hasOwnProperty('filtroSetarDataAtualizada')) {
              self.$refs['fil-com-fec-filtro'].filtroSetarDataAtualizada()
            }

            if (callback !== null) {
              callback()
            }
          }, function (apiError) {
            self.comGerFechamentoErroAPi(apiError)
          })
        } else if (callback !== null) {
          callback()
        }
      },
      comGerFechamentoEnviarForm: function () {
        var self = this

        // MOSTRA O CAMPO VENCIMENTO
        self.formulario.field.vencimento.mostrar = true

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario.field, {}, function (formData) {
          // MOSTRA O CAMPO VENCIMENTO
          self.formulario.field.vencimento.mostrar = false

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA A DATA INICIAL SELECIONADA
          formData.per_ini = self.formulario.field.data.dataIni

          // SETA A DATA FINAL SELECIONADA
          formData.per_fin = self.formulario.field.data.dataFim

          // INICIA AS VARIAVEIS QUE SERÁ ENVIADO A API
          if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, null, null, null, null, false) === true) {
            formData.j_ven_pro = []
          }
          if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === true) {
            formData.j_ven_ser = []
          }

          // PROCURA A COLUNA DO CHECKBOX
          var indexColuna = self.tabelaProduto.coluna.findIndex(item => item.chave === 'checkbox')
          var checkboxMerge = self.tabelaProduto.coluna[indexColuna].checked.concat(self.tabelaServico.coluna[indexColuna].checked)

          for (var key in checkboxMerge) {
            if (checkboxMerge[key] !== 'val_checkbox') {
              // PEGA O VALOR DO CHECKBOX
              var item = checkboxMerge[key].split('_')

              // ADICIONA O VALOR AO FORMULARIO DE ENVIO DA API
              switch (item[1]) {
                case 'P':
                  formData.j_ven_pro.push(item[2])
                  break

                case 'S':
                  formData.j_ven_ser.push(item[2])
                  break
              }
            }
          }

          formData.id_con = self.formulario.field.comissionado.value !== '' ? Number(self.formulario.field.comissionado.value) : ''

          var formEnvia = { lot: [] }
          formEnvia.lot.push(formData)

          self.$store.state.comunicaAPI('/comissao/fechamento', 'POST', formEnvia, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
              self.time = new Date().getTime()

              // // CHAMA A FUNÇÃO PARA ATUALIZAR O COMPONENT
              // self.comGerFechamentoInicia()

              if (apiSuccess.lot[0].code === '200') {
                self.cpntFecharFormulario(true) 
              }
            })
          }, function (apiError) {
            self.comGerFechamentoErroAPi(apiError)
          }, function (apiValid, apiStatus) {
            // eslint-disable-next-line
            console.warn(apiValid, apiStatus)
          })
        })
      },
      comGerFechamentoErroAPi: function (error) {
        // SETA O ERRO RECEBIDO
        this.statusGeral = error

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      comGerFechamentoCriarFiltroApi: function () {
        var where = {
          aAnd: [
            { f: 'status', o: '=', v: '1' },
            { m: 'venda', f: 'status', o: '=', v: '1' },
            { f: 'cms_fec_id', o: 'isNull' },
            { f: 'cms_com_id', o: '=', v: this.formulario.field.comissionado.value }
          ]
        }

        return where
      },
      comGerFechamentoTabelaIniciar: function () {
        var self = this

        self.tabelaProduto = {}
        self.tabelaServico = {}

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        if (self.formulario.field.comissionado.value === '') {
          self.comGerFechamentoTabelaFinalizar()
        } else {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
          self.tabelaProduto = {
            status: 'carregando',
            id: 'cms-pro',
            linha: [],
            linha2: [],
            flagDiff: false,
            montarTabelaCompleta: false
          }

          self.tabelaProduto.coluna = [
            { mPer: 3, tipo: 'RF-Checkbox-Opcional', ref: 'val_checkbox', chave: 'checkbox', checked: [ 'val_checkbox' ] },
            { mPer: 2, chave: 'rf-cod_venda', nome: 'Venda' },
            // { mPer: 2, chave: 'id_con_nome', tipo: 'link-contato', nome: 'Cliente', click: false, converte: { id: 'id_con', nome: 'id_con_nome', empresa: 'id_con_empresa', pessoa: 'id_con_pessoa', status: 'id_con_status' }, mostrarButton: true },
            // { mPer: 3, chave: 'tipo', nome: 'Tipo' },
            // { mPer: 3, chave: 'val_checkbox', nome: 'Cod.' },
            { mPer: 3, chave: 'cod_venda_vencimento', nome: 'Vencimento', click: false },
            { mPer: 3, chave: 'rf-nome', nome: 'Nome', click: false },
            { mPer: 3, chave: 'cms_bc', nome: 'Base de cálculo', converte: { tipo: 'valorMoeda' } },
            { mPer: 3, chave: 'cms_por', nome: 'Porcentagem', converte: { tipo: 'valorDecimal', tipoMask: 'valor_mask', mask: '%' } },
            { mPer: 3, chave: 'rf-cms_valor', nome: 'Valor', converte: { tipo: 'valorMoeda' } }
          ]

          // SETA O INDEX DA COLUNA DO CHECKBOX
          self.tabelaProduto.checkboxIndex = self.tabelaProduto.coluna.findIndex(item => item.hasOwnProperty('chave') && item.chave === 'checkbox')
          
          // // SETA A VARIAVEL DE CHECKBOX
          // self.checkbox = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // COPIA OS DADOS INICIAL DO 
          self.tabelaServico = JSON.parse(JSON.stringify(self.tabelaProduto))
          self.tabelaServico.id = 'cms-ser'

          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabelaProduto, function (tabelaSuccess) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabelaProduto = tabelaSuccess

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
            self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabelaServico, function (tabelaSuccess) {
              // SETA OS DADOS RECEBIDOS PARA TABELA
              self.tabelaServico = tabelaSuccess

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR AS VENDAS NÃO EXCLUIDAS
              self.comGerFechamentoBuscaVenda()
            }, function (tabelaError) {
              // SETA OS DADOS RECEBIDOS PARA TABELA
              self.tabelaServico.status = tabelaError

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          }, function (tabelaError) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabelaProduto.status = tabelaError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        }
      },
      comGerFechamentoBuscaVenda: function () {
        var self = this

        // CRIA O QUERYGET QUE SERÁ REALIZADO NA API
        var queryGet = { type: 'list', return: 'arrayGroupByField', field: { cod_venda: null, id_con: null, id_vei: null }, where: { aAnd: [ { f: 'status', o: '<>', v: '3' } ] } }

        if (self.formulario.field.hasOwnProperty('data') && self.formulario.field.data.dataIni !== '' && self.formulario.field.data.dataFim !== '') {
          var dataIni = self.formulario.field.data.dataIni.split('/')
          var dataFim = self.formulario.field.data.dataFim.split('/')

          queryGet.where.aAnd.push({ f: 'vencimento', o: '>=', v: dataIni[2] + '-' + dataIni[1] + '-' + dataIni[0] })
          queryGet.where.aAnd.push({ f: 'vencimento', o: '<=', v: dataFim[2] + '-' + dataFim[1] + '-' + dataFim[0] })
        }

        self.$store.state.comunicaAPI('/venda/get', 'POST', queryGet, function (apiSuccess) {
          // SETA OS CONTATOS DAS VENDAS RECEBIDOS
          self.vendaConIds = apiSuccess.data.id_con.split(',')

          // SETA OS CONTATOS DAS VENDAS RECEBIDOS
          self.vendaVeiIds = apiSuccess.data.id_vei.split(',')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
            
          // CHAMA A FUNÇÃO PARA BUSCAR OS PRODUTOS
          self.comGerFechamentoBuscaProduto()
        }, function (apiError) {
          self.comGerFechamentoErroAPi(apiError)
        })
      },
      comGerFechamentoBuscaProduto: function () {
        var self = this

        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, null, null, null, null, false) === true) {
          // CRIA O QUERYGET QUE SERÁ REALIZADO NA API
          var queryGet = { type: 'list', return: 'dataAll', field: { id: null, id_pro: { j: { nome: null, status: null } }, cms_bc: null, cms_por: null, cms_valor: null, cod_venda: { j: { vencimento: null, id_con: null, id_vei: null } } }, where: { aAnd: [ { m: 'venda', f: 'status', o: '=', v: '2' }, { f: 'status', o: '=', v: '1' }, { f: 'cms_fec_id', o: 'isNull' }, { f: 'cms_com_id', o: '=', v: self.formulario.field.comissionado.value } ] } }

          if (self.formulario.field.hasOwnProperty('data') && self.formulario.field.data.dataIni !== '' && self.formulario.field.data.dataFim !== '') {
            var dataIni = self.formulario.field.data.dataIni.split('/')
            var dataFim = self.formulario.field.data.dataFim.split('/')

            queryGet.where.aAnd.push({ m: 'venda', f: 'vencimento', o: '>=', v: dataIni[2] + '-' + dataIni[1] + '-' + dataIni[0] })
            queryGet.where.aAnd.push({ m: 'venda', f: 'vencimento', o: '<=', v: dataFim[2] + '-' + dataFim[1] + '-' + dataFim[0] })
          }

          self.$store.state.comunicaAPI('/venda/produto/get', 'POST', queryGet, function (apiSuccess) {
            // if (apiSuccess.data.length >= 1) {
            //   self.tabelaProduto.fraseTop = [ '<i class="fas fa-angle-double-right"></i> PRODUTOS' ]
            // }

            var ids = []

            for (var key in apiSuccess.data) {
              apiSuccess.data[key].tipo = 'Produto'

              apiSuccess.data[key]['val_checkbox'] = apiSuccess.data[key].cod_venda + '_P_' + apiSuccess.data[key].id
              // self.tabelaProduto.coluna[self.tabelaProduto.checkboxIndex].checked.push(apiSuccess.data[key]['val_checkbox'])
              // self.checkbox.push(apiSuccess.data[key]['val_checkbox'])

              apiSuccess.data[key]['rf-id'] = apiSuccess.data[key].id_pro
              apiSuccess.data[key]['rf-nome'] = apiSuccess.data[key].id_pro_nome

              ids.push(apiSuccess.data[key].id_pro)

              // delete apiSuccess.data[key].id_pro
              delete apiSuccess.data[key].id_pro_nome
            }

            // SETA OS VALORES RECEBIDOS
            self.tabelaProduto.linha = apiSuccess.data

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // MONSTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id_pro: null, cms_por: null }, where: { aAnd: [ { f: 'id_con', o: '=', v: self.formulario.field.comissionado.value }, { f: 'id_pro', o: 'in', v: ids.join() } ] } }

            // CHAMA FUNÇÃO PARA COMUNICAR COM API
            self.$store.state.comunicaAPI('/comissao/config/comissionado/produto/get/', 'GET', queryGet, function (apiSuccess) {
              for (var key in self.tabelaProduto.linha) {
                var diferencao = apiSuccess.data.filter(item => item.id_pro === self.tabelaProduto.linha[key].id_pro)
                if (diferencao.length >= 1) {
                  diferencao = diferencao[0]

                  if (self.tabelaProduto.linha[key].cms_por !== diferencao.cms_por) {
                    self.tabelaProduto.linha[key].diff = (self.$store.state.FUN_MASK_VALOR('valorDecimal', self.tabelaProduto.linha[key].cms_por) + ' %') + ' -> ' + self.$store.state.FUN_MASK_VALOR('valorDecimal', diferencao.cms_por) + ' %'
                  } else {
                    self.tabelaProduto.linha[key].diff = ''
                  }
                } else {
                  self.tabelaProduto.linha[key].diff = ''
                }
              }

              // CHAMA A FUNÇÃO PARA BUSCAR OS SERVIÇOS
              self.comGerFechamentoBuscaServico()
            }, function (apiError) {
              self.comGerFechamentoErroAPi(apiError)
            })
          }, function (apiError) {
            self.comGerFechamentoErroAPi(apiError)
          })
        } else {
          // CHAMA A FUNÇÃO PARA BUSCAR OS SERVIÇOS
          self.comGerFechamentoBuscaServico()
        }
      },
      comGerFechamentoBuscaServico: function () {
        var self = this

        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === true) {
          // CRIA O QUERYGET QUE SERÁ REALIZADO NA API
          var queryGet = { type: 'list', return: 'dataAll', field: { id: null, id_ser: { j: { nome: null, status: null } }, cms_bc: null, cms_por: null, cms_valor: null, cod_venda: { j: { vencimento: null, id_con: null, id_vei: null } } }, where: { aAnd: [ { m: 'venda', f: 'status', o: '=', v: '2' }, { f: 'status', o: '=', v: '1' }, { f: 'cms_fec_id', o: 'isNull' }, { f: 'cms_com_id', o: '=', v: self.formulario.field.comissionado.value } ] } }

          if (self.formulario.field.hasOwnProperty('data') && self.formulario.field.data.dataIni !== '' && self.formulario.field.data.dataFim !== '') {
            var dataIni = self.formulario.field.data.dataIni.split('/')
            var dataFim = self.formulario.field.data.dataFim.split('/')

            queryGet.where.aAnd.push({ m: 'venda', f: 'vencimento', o: '>=', v: dataIni[2] + '-' + dataIni[1] + '-' + dataIni[0] })
            queryGet.where.aAnd.push({ m: 'venda', f: 'vencimento', o: '<=', v: dataFim[2] + '-' + dataFim[1] + '-' + dataFim[0] })
          }

          self.$store.state.comunicaAPI('/venda/servico/get', 'POST', queryGet, function (apiSuccess) {
            // if (apiSuccess.data.length >= 1) {
            //   self.tabelaServico.fraseTop = [ '<i class="fas fa-angle-double-right"></i> SERVIÇOS' ]
            // }

            var ids = []

            for (var key in apiSuccess.data) {
              apiSuccess.data[key].tipo = 'Serviço'

              apiSuccess.data[key]['val_checkbox'] = apiSuccess.data[key].cod_venda + '_S_' + apiSuccess.data[key].id
              // self.tabelaServico.coluna[self.tabelaServico.checkboxIndex].checked.push(apiSuccess.data[key]['val_checkbox'])
              // self.checkbox.push(apiSuccess.data[key]['val_checkbox'])

              apiSuccess.data[key]['rf-id'] = apiSuccess.data[key].id_ser
              apiSuccess.data[key]['rf-nome'] = apiSuccess.data[key].id_ser_nome

              ids.push(apiSuccess.data[key].id_ser)

              // delete apiSuccess.data[key].id_ser
              delete apiSuccess.data[key].id_ser_nome
            }

            // SETA OS VALORES RECEBIDOS
            self.tabelaServico.linha = apiSuccess.data
            // self.tabelaServico.linha = self.tabelaServico.linha.concat(apiSuccess.data)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // MONSTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id_ser: null, cms_por: null }, where: { aAnd: [ { f: 'id_con', o: '=', v: self.formulario.field.comissionado.value }, { f: 'id_ser', o: 'in', v: ids.join() } ] } }

            // CHAMA FUNÇÃO PARA COMUNICAR COM API
            self.$store.state.comunicaAPI('/comissao/config/comissionado/servico/get/', 'GET', queryGet, function (apiSuccess) {
              for (var key in self.tabelaServico.linha) {
                var diferencao = apiSuccess.data.filter(item => item.id_ser === self.tabelaServico.linha[key].id_ser)
                if (diferencao.length >= 1) {
                  diferencao = diferencao[0]

                  if (self.tabelaServico.linha[key].cms_por !== diferencao.cms_por) {
                    self.tabelaServico.linha[key].diff = (self.$store.state.FUN_MASK_VALOR('valorDecimal', self.tabelaServico.linha[key].cms_por) + ' %') + ' -> ' + self.$store.state.FUN_MASK_VALOR('valorDecimal', diferencao.cms_por) + ' %'
                  } else {
                    self.tabelaServico.linha[key].diff = ''
                  }
                } else {
                  self.tabelaServico.linha[key].diff = ''
                }
              }

              // CHAMA A FUNÇÃO PARA BUSCAR OS CONTATO
              self.comGerFechamentoBuscaContato()
            }, function (apiError) {
              self.comGerFechamentoErroAPi(apiError)
            })
          }, function (apiError) {
            self.comGerFechamentoErroAPi(apiError)
          })
        } else {
          // CHAMA A FUNÇÃO PARA BUSCAR OS CONTATO
          self.comGerFechamentoBuscaContato()
        }
      },
      comGerFechamentoBuscaContato: function () {
        var self = this

        // CRIA O QUERYGET QUE SERÁ REALIZADO NA API
        var queryGet = { type: 'list', return: 'dataAll', field: { id: { a: 'id_con' }, nome: { a: 'id_con_nome' }, empresa: { a: 'id_con_empresa' }, pessoa: { a: 'id_con_pessoa' }, status: { a: 'id_con_status' } }, where: { f: 'id', o: 'in', v: self.vendaConIds.join() } }

        self.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, function (apiSuccess) {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS DE VEICULO
          self.comGerFechamentoBuscaVeiculo(apiSuccess.data)
        }, function (apiError) {
          self.comGerFechamentoErroAPi(apiError)
        })
      },
      comGerFechamentoBuscaVeiculo: function (contato) {
        var self = this

        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
          // CRIA O QUERYGET QUE SERÁ REALIZADO NA API
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: { a: 'id_vei' }, placa: { a: 'id_vei_placa' }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } }, id_mar: { j: { nome: null } }, id_mod: { j: { nome: null } }, status: { a: 'id_vei_status' } }, where: { f: 'id', o: 'in', v: self.vendaVeiIds.join() } }

          self.$store.state.comunicaAPI('/veiculo/get', 'POST', queryGet, function (apiSuccess) {
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA TRATAR OS VALORES RECEBIDOS
            self.comGerFechamentoTabelaTratarValor(contato, apiSuccess.data)
          }, function (apiError) {
            self.comGerFechamentoErroAPi(apiError)
          })
        } else {
          // CHAMA A FUNÇÃO PARA TRATAR OS VALORES RECEBIDOS
          self.comGerFechamentoTabelaTratarValor(contato, [])
        }
      },
      comGerFechamentoTabelaTratarLinhas: function (contatos, veiculos, tabelaTipo, callback) {
        var self = this

        // if (self[tabelaTipo].linha.length === 0) {
        //   self[tabelaTipo].coluna[self[tabelaTipo].checkboxIndex].checked = []
        // } else {
        //   self[tabelaTipo].coluna[self[tabelaTipo].checkboxIndex].checked = [ 'val_checkbox' ]
        // }

        var vendaId = ''
        self[tabelaTipo].calculos = { bc: 0, por: 0, val: 0 }
        self[tabelaTipo].linha2 = []
        self[tabelaTipo].rowspan = {}

        // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
        vendaId = ''
        var corLinha = 'rf-cms-venda-cinza'
        var contaRowspan = 0
        var vendaItens = {}

        for (var key in self[tabelaTipo].linha) {
          // PEGA OS DADOS DOS PRODUTOS E SERVIÇOS
          vendaItens = self[tabelaTipo].linha[key]

          if (vendaId === '' || Number(self[tabelaTipo].linha[key].cod_venda) !== Number(self[tabelaTipo].linha[vendaId].cod_venda)) {
            // SETA COMO REFERENCIA O ID QUE ESTA PEGANDO OS DADOS DA VENDA
            vendaId = key

            if (contaRowspan >= 1) {
              // ADICIONA O ROWSPAN QUE FOI CONTADO
              self[tabelaTipo].rowspan[(self[tabelaTipo].linha2.length - contaRowspan)] = { 'rf-cod_venda': contaRowspan }
            }

            // VERIFICA QUAL É A COR DA LINHA QUE DEVE FICAR
            if (corLinha === 'rf-cms-venda-branco') {
              corLinha = 'rf-cms-venda-cinza'
            } else if (corLinha === 'rf-cms-venda-cinza') {
              corLinha = 'rf-cms-venda-branco'
            }

            // INICIA A VARIAVEL PARA CONTAR QUANTOS ROWSPAN DEVE FAZER NA PRIMEIRA COLUNA
            contaRowspan = 0

            // SETA OS DADOS DOS CONTATOS
            vendaItens = Object.assign(vendaItens, contatos.filter(item => item.id_con === self[tabelaTipo].linha[key].cod_venda_id_con)[0])

            // SETA OS DADOS DOS CONTATOS
            if (veiculos.length >= 1 && [ '', '0' ].indexOf(self[tabelaTipo].linha[key].cod_venda_id_vei) === -1) {
              vendaItens = Object.assign(vendaItens, veiculos.filter(item => item.id_vei === self[tabelaTipo].linha[key].cod_venda_id_vei)[0])

              if (vendaItens.hasOwnProperty('id_vei_placa')) {
                vendaItens.id_vei_placa = vendaItens.id_vei_placa + ' '

                if (vendaItens.ref_modelo === '') {
                  vendaItens.id_vei_placa += vendaItens.id_mar_nome + ' ' + vendaItens.id_mod_nome
                } else {
                  vendaItens.id_vei_placa += vendaItens.ref_modelo_id_marca_j_marca + ' ' + vendaItens.ref_modelo_j_modelo
                }
              }
            }
          }

          if (contaRowspan === 0) {
            vendaItens['rf-cod_venda'] = []

            // ADICIONA O BOTÃO DA VENDA NA TABELA
            vendaItens['rf-cod_venda'].push({
              tipo: 'button',
              tipoButton: 'texto',
              texto: (self[tabelaTipo].linha[key].cod_venda_status === '1' ? 'O' : 'V') + ' ' + ((self[tabelaTipo].linha[key].cod_venda.length <= 4 ? ('0000' + self[tabelaTipo].linha[key].cod_venda).slice(-4) : self[tabelaTipo].linha[key].cod_venda)),
              id: self[tabelaTipo].id + '-rf-cod_venda-0-' + self[tabelaTipo].linha[key].cod_venda,
              status: '',
              disabled: false,
              class: 'btn btn-sm ' + (self[tabelaTipo].linha[key].cod_venda_status === '1' ? 'btn-warning' : 'btn-primary'),
              onClick: function (indexL) {
                self.$store.state.OPEN_PAGE_CS(self.$router.resolve({ name: 'abrir_doc_id', params: { cts: self.$store.state.token.cts, nome: 'venda', id: self[tabelaTipo].linha[indexL].cod_venda, tipo: 'recibo', formato: 'html' } }).href, '_blank', {}, false)
              }
            })

            var infoVenda = ''
            infoVenda += '<table>'
            infoVenda += '<tr><td>Cliente:&nbsp;</td><td>' + self[tabelaTipo].linha[key].id_con_nome + '</td></tr>'

            if ([ '', 0, '0' ].indexOf(self[tabelaTipo].linha[key].cod_venda_id_vei) === -1) {
              infoVenda += '<tr><td>Veículo:&nbsp;</td><td>' + self[tabelaTipo].linha[key].id_vei_placa + '</td></tr>'
            }
            infoVenda += '<table>'

            vendaItens['rf-cod_venda'].push({
              tipo: 'explica',
              mensagem: infoVenda
            })

            // // COLOCA O VENCIMENTO DA VENDA
            // // vendaItens['rf-cod_venda'].push('<br/><br/> em ' + self[tabelaTipo].linha[key].cod_venda_vencimento)

            // // ADICIONA O BOTÃO DE VEICULO NA VENDA
            // vendaItens['rf-cod_venda'].push({
            //   tipo: 'link-contato',
            //   converte: { id: 'id_con', nome: 'id_con_nome', empresa: 'id_con_empresa', pessoa: 'id_con_pessoa', status: 'id_con_status' },
            //   mostrarButton: true
            // })

            // // ADICIONA O BOTÃO DE VEICULO NA VENDA
            // vendaItens['rf-cod_venda'].push({
            //   tipo: 'link-veiculo',
            //   converte: { id: 'id_vei', placa: 'id_vei_placa', status: 'id_vei_status' },
            //   mostrarButton: true
            // })
          }

          // CONTA QUANTAS LINHA DEVE SER COLOCADO O ROWSPAN
          contaRowspan = contaRowspan + 1

          vendaItens['rf-cms_valor'] = []

          if (self[tabelaTipo].linha[key].diff !== '') {
            // ADICIONA O TRIANGULO COM A INFORMAÇÃO DE UMA DIFERENÇA
            vendaItens['rf-cms_valor'].push({
              tipo: 'button',
              tipoButton: 'icone',
              icone: {
                tipo: 'alerta',
                id: self[tabelaTipo].id + '--cms_por-0--' + self[tabelaTipo].linha[key].cod_venda + '--' + self[tabelaTipo].linha[key].id,
                mostrar: true,
              },
              id: self[tabelaTipo].id + '--cms_por-1--' + self[tabelaTipo].linha[key].cod_venda + '--' + self[tabelaTipo].linha[key].id,
              status: '',
              disabled: false,
              class: 'btn btn-sm btn-default',
              mostrar: true,
              explica: { mensagem: self[tabelaTipo].linha[key].diff, positionMy: 'top right', positionAt: 'bottom left' },
              onClick: function (indexL) {
                self.comGerFechamentoAtaulizarPorcentagemItem(self[tabelaTipo].linha[indexL].cod_venda, self[tabelaTipo].linha[indexL].id, self[tabelaTipo].linha[indexL].hasOwnProperty('id_pro') ? 'produto' : 'servico')
              }
            })

            // SETA O FLAG QUE EXISTE UMA DIFERENÇA DO CADASTRO ATUAL PARA VENDA
            self[tabelaTipo].flagDiff = true
          }

          vendaItens['rf-cms_valor'].push(vendaItens.cms_valor)

          // vendaItens['rf-cms_valor'].push({
          //   tipo: 'explica',
          //   mensagem: "<table><tr><td>Base de cálculo: </td><td>&nbsp;</td><td>" + self.$store.state.FUN_MASK_VALOR('valorMoeda', self[tabelaTipo].linha[key].cms_bc.toString()) + "</td></tr><tr><td>Porcentagem média:</td><td>&nbsp;</td><td>" + self.$store.state.FUN_MASK_VALOR('valorDecimal', self[tabelaTipo].linha[key].cms_por.toString()) + "%</td></tr></table>",
          //   posicaoMy: 'top right',
          //   posicaoAt: 'bottom left' 
          // })

          // ADICIONA A COLUNA CHECKBOX
          vendaItens.checkbox = [ { tipo: 'checkbox' } ]
          // self[tabelaTipo].coluna[self[tabelaTipo].checkboxIndex].checked.push(vendaItens.val_checkbox)
          // self.checkbox.push(vendaItens.val_checkbox)

          // SETA A COR DA LINHA QUE DEVE UTILIZAR
          vendaItens.rfClassTr = corLinha + ' rf-cms-itens-ven'
          vendaItens.rfClassTrFocus = corLinha + ' rf-cms-itens-ven'

          // REALIZA OS CALCULOS GERAIS
          self[tabelaTipo].calculos.bc += Number(self[tabelaTipo].linha[key].cms_bc)
          self[tabelaTipo].calculos.val += Number(self[tabelaTipo].linha[key].cms_valor)

          // ADICIONA A LINHA DE PRODUTO OU SERVICO NA TABELA
          self[tabelaTipo].linha2.push(vendaItens)
        }

        if (contaRowspan >= 1) {
          // ADICIONA O ROWSPAN QUE FOI CONTADO
          self[tabelaTipo].rowspan[(self[tabelaTipo].linha.length - contaRowspan)] = { 'rf-cod_venda': contaRowspan }
        }

        // ADICIONA AS INFORMAÇÕES NO TOP DA TABELA
        if (self[tabelaTipo].linha.length >= 1) {
          self[tabelaTipo].calculos.por = ((self[tabelaTipo].calculos.val / self[tabelaTipo].calculos.bc) * 100)
          
          // ARREDONDA PARA 4 CASAS DECIMAIS
          if (self[tabelaTipo].calculos.por > 0) {
            self[tabelaTipo].calculos.por = self[tabelaTipo].calculos.por.toFixed(4)
          }

          self[tabelaTipo].calculos.bc_formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self[tabelaTipo].calculos.bc.toString())
          self[tabelaTipo].calculos.por_formatado = self.$store.state.FUN_MASK_VALOR('valorDecimal', self[tabelaTipo].calculos.por.toString())
          self[tabelaTipo].calculos.val_formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self[tabelaTipo].calculos.val.toString())
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        callback()
      },
      comGerFechamentoTabelaTratarValor: function (contatos, veiculos) {
        var self = this

        self.comGerFechamentoTabelaTratarLinhas(contatos, veiculos, 'tabelaProduto', function () {
          self.comGerFechamentoTabelaTratarLinhas(contatos, veiculos, 'tabelaServico', function () {
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
            
            // CHAMA A FUNÇÃO PARA FINALIZAR A TABELA
            self.comGerFechamentoTabelaFinalizar()
          })          
        })
      },
      comGerFechamentoAtaulizarAllPorcentagemItem: function (comunica = {}) {
        var self = this

        if (Object.keys(comunica).length === 0) {
          if (confirm('Confirma atualizar todas as porcentagens divergentes?')) {
            // SETA O STATUS DO BUTTON
            self.buttonDiff.status = 'carregando'

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            var key = ''

            if (self.tabelaProduto.flagDiff === true) {
              comunica.produto = {
                _method: 'PUT',
                lot: []
              }

              for (key in self.tabelaProduto.linha) {
                if (self.tabelaProduto.linha[key].diff !== '') {
                  comunica.produto.lot.push({
                    cod_venda: self.tabelaProduto.linha[key].cod_venda,
                    id: self.tabelaProduto.linha[key].id,
                    cms_com_id: self.formulario.field.comissionado.value
                  })
                }
              }
            }

            if (self.tabelaServico.flagDiff === true) {
              comunica.servico = {
                _method: 'PUT',
                lot: []
              }

              for (key in self.tabelaServico.linha) {
                if (self.tabelaServico.linha[key].diff !== '') {
                  comunica.servico.lot.push({
                    cod_venda: self.tabelaServico.linha[key].cod_venda,
                    id: self.tabelaServico.linha[key].id,
                    cms_com_id: self.formulario.field.comissionado.value
                  })
                }
              }
            }

            // CHAMA A FUNÇÃO PARA COMUNICAR COM A API
            self.comGerFechamentoAtaulizarAllPorcentagemItem(comunica)
          }
        } else {
          if (comunica.hasOwnProperty('produto') && comunica.produto !== '') {
            self.$store.state.comunicaAPI('/venda/produto', 'PUT', comunica.produto, function () {
              // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
              self.time = new Date().getTime()

              // LIMPA OS DADOS SALVOS
              comunica.produto = ''

              // CHAMA A FUNÇÃO PARA COMUNICAR COM A API
              self.comGerFechamentoAtaulizarAllPorcentagemItem(comunica)
            }, function (apiError) {
              self.comGerFechamentoErroAPi(apiError)
            })
          } else if (comunica.hasOwnProperty('servico') && comunica.servico  !== '') {
            self.$store.state.comunicaAPI('/venda/servico', 'PUT', comunica.servico, function () {
              // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
              self.time = new Date().getTime()

              // LIMPA OS DADOS SALVOS
              comunica.servico = ''

              // CHAMA A FUNÇÃO PARA COMUNICAR COM A API
              self.comGerFechamentoAtaulizarAllPorcentagemItem(comunica)
            }, function (apiError) {
              self.comGerFechamentoErroAPi(apiError)
            })
          } else {
            // APRESENTA A MENSAGEM DE SUCESSO
            self.$store.state.msgWarn('WEB [200]: Todos os itens foram atualizados.', 'success')

            // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA ATUALIZAR OS TOTAIS DA VENDA
            self.comGerFechamentoTabelaIniciar()
          }
        }
      },
      comGerFechamentoAtaulizarPorcentagemItem: function (venda, item, tipo) {
        var self = this

        if (confirm('Confirma atualizar para a porcentagem atual neste item?')) {
          var formData = {
            _method: 'PUT',
            lot: []
          }

          formData.lot.push({
            cod_venda: venda,
            id: item,
            cms_com_id: self.formulario.field.comissionado.value
          })

          self.$store.state.comunicaAPI('/venda/' + tipo, 'PUT', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA ATUALIZAR OS TOTAIS DA VENDA
              self.comGerFechamentoTabelaIniciar()
            })
          }, function (apiError) {
            self.comGerFechamentoErroAPi(apiError)
          })
        }
      },
      comGerFechamentoTabelaFinalizar: function () {
        var self = this

        if (Object.keys(self.tabelaProduto).length >= 1 || Object.keys(self.tabelaServico).length >= 1) {
          if (self.tabelaProduto.flagDiff === true || self.tabelaServico.flagDiff === true) {
            self.buttonDiff = {
              id: 'cms-button-diff-all',
              status: '',
              tipo: 'texto',
              texto: 'Atualizar todos',
              class: [ 'btn', 'btn-default', 'btn-sm' ],
              onClick: function () {
                self.comGerFechamentoAtaulizarAllPorcentagemItem()
              }
            }
          }

          // CALCULA O TOTAL DA BASE DE CALCULO
          self.tabelaTotais.bc = self.tabelaProduto.calculos.bc + self.tabelaServico.calculos.bc

          // CALCULA O TOTAL DO VALOR DA COMISSÃO
          self.tabelaTotais.val = self.tabelaProduto.calculos.val + self.tabelaServico.calculos.val

          // CALCULA A PORCENTAGEM DO VALOR A SER APLICADO
          if (self.tabelaTotais.val > 0 || self.tabelaTotais.bc > 0) {
            self.tabelaTotais.por = ((self.tabelaTotais.val / self.tabelaTotais.bc) * 100)
          }

          if (self.tabelaTotais.por > 0 && typeof self.tabelaTotais.por === 'number') {
            self.tabelaTotais.por = self.tabelaTotais.por.toFixed(4)
          }

          self.tabelaTotais.bc_formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.tabelaTotais.bc.toString())
          self.tabelaTotais.por_formatado = self.$store.state.FUN_MASK_VALOR('valorDecimal', self.tabelaTotais.por.toString())
          self.tabelaTotais.val_formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.tabelaTotais.val.toString())

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA QUE ESTA CALCULANDO O VALOR SELECIONADO
          self.tabelaTotaisSelecionado.somando = true

          // VERIFICA SE TEM ALGUMA COISA NA TABELA
          if (self.tabelaProduto.hasOwnProperty('status')) {          
            self.comGerFechamentoTabelaMarcarAllChecks('tabelaProduto')
          }

          // VERIFICA SE TEM ALGUMA COISA NA TABELA
          if (self.tabelaServico.hasOwnProperty('status')) {
            self.comGerFechamentoTabelaMarcarAllChecks('tabelaServico')
          }

          setTimeout(function () {
            // VERIFICA SE TEM ALGUMA COISA NA TABELA
            if (self.tabelaProduto.hasOwnProperty('status')) {
              self.tabelaProduto.status = ''
            }

            // VERIFICA SE TEM ALGUMA COISA NA TABELA
            if (self.tabelaServico.hasOwnProperty('status')) {
              self.tabelaServico.status = ''
            }

            // VERIFICA SE TEM ALGUMA COISA NA TABELA
            if (self.tabelaTotais.hasOwnProperty('status')) {
              self.tabelaTotais.status = ''
            }

            self.comGerFechamentoBuscarPeriodo(function () {
              // SETA QUE ESTA CALCULANDO O VALOR SELECIONADO
              self.tabelaTotaisSelecionado.somando = false

              // CHAMA A FUNÇÃO PARA CALCULAR OS VALORES SELECIONADOS
              self.comGerFechamentoCalcularSelecionados()

              // SETA O STATUS DOS FORMULARIO
              self.statusGeral = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          }, 500)
        } else {
          // VERIFICA SE TEM ALGUMA COISA NA TABELA
          if (self.tabelaProduto.hasOwnProperty('status')) {
            self.tabelaProduto.status = ''
          }

          // VERIFICA SE TEM ALGUMA COISA NA TABELA
          if (self.tabelaServico.hasOwnProperty('status')) {
            self.tabelaServico.status = ''
          }

          // SETA O STATUS DOS FORMULARIO
          self.statusGeral = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }
      },
      comGerFechamentoTabelaMarcarAllChecks: function (tipo = '', tentativa = 0) {
        var self = this

        setTimeout(function () {
          if (self.$refs.hasOwnProperty(self[tipo].id) && self.$refs[self[tipo].id].hasOwnProperty('onChangeCheckbox')) {
            // SETA O FOCUS NO CAMPO
            self.$refs[self[tipo].id].onChangeCheckbox(true, self[tipo].id + '-RF-Checkbox-Opcional--all--0')

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          } else if (tentativa <= 10) {
            self.comGerFechamentoTabelaMarcarAllChecks(tipo, (tentativa + 1))
          }
        }, 50)
      },
      comGerFechamentoCalcularSelecionados: function () {
        var self = this
        var key = ''

        if (self.tabelaTotaisSelecionado.somando === false) {
          // SETA QUE ESTA CALCULANDO O VALOR SELECIONADO
          self.tabelaTotaisSelecionado.somando = true

          // RESETA OS VALORES PARA CALCULAR NOVAMENTE
          self.tabelaTotaisSelecionado.bc = 0
          self.tabelaTotaisSelecionado.por = 0
          self.tabelaTotaisSelecionado.val = 0

          for (key in self.tabelaProduto.linha2) {
            if (self.tabelaProduto.coluna[self.tabelaProduto.checkboxIndex].checked.indexOf(self.tabelaProduto.linha2[key].val_checkbox) !== -1) {
              if (self.tabelaProduto.linha2[key].hasOwnProperty('cms_bc')) {
                self.tabelaTotaisSelecionado.bc += Number(self.tabelaProduto.linha2[key].cms_bc)
              }

              if (self.tabelaProduto.linha2[key].hasOwnProperty('cms_valor')) {
                self.tabelaTotaisSelecionado.val += Number(self.tabelaProduto.linha2[key].cms_valor)
              }
            }
          }

          for (key in self.tabelaServico.linha2) {
            if (self.tabelaServico.coluna[self.tabelaServico.checkboxIndex].checked.indexOf(self.tabelaServico.linha2[key].val_checkbox) !== -1) {
              if (self.tabelaServico.linha2[key].hasOwnProperty('cms_bc')) {
                self.tabelaTotaisSelecionado.bc += Number(self.tabelaServico.linha2[key].cms_bc)
              }

              if (self.tabelaServico.linha2[key].hasOwnProperty('cms_valor')) {
                self.tabelaTotaisSelecionado.val += Number(self.tabelaServico.linha2[key].cms_valor)
              }
            }
          }

          // CALCULA O VALOR DA PORCENTAGEM
          self.tabelaTotaisSelecionado.por = ((self.tabelaTotaisSelecionado.val / self.tabelaTotaisSelecionado.bc) * 100)

          // ARREDONDA PARA 4 CASAS
          if (self.tabelaTotaisSelecionado.por > 0) {
            self.tabelaTotaisSelecionado.por = self.tabelaTotaisSelecionado.por.toFixed(4)
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            // FORMATA TODOS OS VALORES
            self.tabelaTotaisSelecionado.bc_formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.tabelaTotaisSelecionado.bc.toString())
            self.tabelaTotaisSelecionado.por_formatado = self.$store.state.FUN_MASK_VALOR('valorDecimal', self.tabelaTotaisSelecionado.por.toString())
            self.tabelaTotaisSelecionado.val_formatado = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.tabelaTotaisSelecionado.val.toString())

            // SETA QUE FINALIZOU A FUNÇÃO DE SOMA
            self.tabelaTotaisSelecionado.somando = false

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, 200)
        }
      },
      comGerFechamentoTabelaOnCheckboxAtualiza: function (coluna = null, checkbox = null, index) {
        if (coluna !== null && checkbox !== null) {
          var tabelaTipo = ''

          // VERIFICA QUAL É A TABELA QUE DEVE SER SETADA
          switch (index[0]) {
            case 'cms-pro-RF-Checkbox-Opcional':
              tabelaTipo = 'tabelaProduto'
              break

            case 'cms-ser-RF-Checkbox-Opcional':
              tabelaTipo = 'tabelaServico'
              break
          }

          if (tabelaTipo !== '') {
            // PROCURA A COLUNA DO CHECKBOX
            var indexColuna = this[tabelaTipo].coluna.findIndex(item => item.chave === coluna)

            // SALVA OS DADOS DO CHECKBOX
            this[tabelaTipo].coluna[indexColuna].checked = checkbox.filter(item => item !== this[tabelaTipo].coluna[indexColuna].chave)

            // CHAMA A FUNÇÃO PARA CALCULAR OS VALORES SELECIONADOS
            this.comGerFechamentoCalcularSelecionados()
          }
        }
      }
    }
  }
</script>
